import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToCreate = ({ classes, ...props}) => {
    console.log('exam_name: ' + props.exam_name)
    return <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/examlogs/create',
            exam_id: props.exam_id,
            exam_name: props.exam_name
        }}
        className={classes.link}
        {...props}
       
    >
        <AddCircleIcon className={classes.icon} />Proceed to Exam
    </Button>
};

export default withStyles(styles)(LinkToCreate);